var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Search, colour=NeutralSubdued, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M20.4295 21L14.1295 14.7C13.6295 15.1 13.0545 15.4167 12.4045 15.65C11.7545 15.8833 11.0629 16 10.3295 16C8.51285 16 6.97535 15.3708 5.71702 14.1125C4.45869 12.8542 3.82952 11.3167 3.82952 9.5C3.82952 7.68333 4.45869 6.14583 5.71702 4.8875C6.97535 3.62917 8.51285 3 10.3295 3C12.1462 3 13.6837 3.62917 14.942 4.8875C16.2004 6.14583 16.8295 7.68333 16.8295 9.5C16.8295 10.2333 16.7129 10.925 16.4795 11.575C16.2462 12.225 15.9295 12.8 15.5295 13.3L21.8295 19.6L20.4295 21ZM10.3295 14C11.5795 14 12.642 13.5625 13.517 12.6875C14.392 11.8125 14.8295 10.75 14.8295 9.5C14.8295 8.25 14.392 7.1875 13.517 6.3125C12.642 5.4375 11.5795 5 10.3295 5C9.07952 5 8.01702 5.4375 7.14202 6.3125C6.26702 7.1875 5.82952 8.25 5.82952 9.5C5.82952 10.75 6.26702 11.8125 7.14202 12.6875C8.01702 13.5625 9.07952 14 10.3295 14Z",
    fill: "#707B8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.1fa1ea27bae4a9231e23ee5b8969c0d4.svg";
export { ForwardRef as ReactComponent };